// Packages
import { cloneDeep } from "lodash";

export const initUpdateActionFw = ({
  selectedFWInstancesList,
}) => {
  const fwList = selectedFWInstancesList
    .map(row => {
      let fw = cloneDeep(row.original);
      return {
        ...fw,
        firmwareList: fw.firmwareList.map(availableFw => {
          return {
            ...cloneDeep(availableFw),
            isSelected: availableFw.version === fw.targetFirmwareVersion,
          }
        })
      }
    })

  return fwList;
}

export const getActionSelectorSendRequestParams = ({
  auth,
}) => {
  const isStandaloneMode = !auth.orgs || Object.keys(auth.orgs).length === 0;
  const apiBaseUrl = isStandaloneMode ? `/orgs/:orgId` : `/ents/:entId/orgs/:orgId`;
  const apiPaths = {
    org: `${apiBaseUrl}/clients.update`,
    site: `${apiBaseUrl}/sites/:siteId/clients.update`
  };
  const apiKey = apiPaths[auth.scopeLevel];

  const restfulParamsConfig = {
    standalone: {
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
    nonStandalone: {
      entId: auth.realm?.id,
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
  };

  const restfulParams = isStandaloneMode ? restfulParamsConfig["standalone"] : restfulParamsConfig["nonStandalone"];

  return {
    apiKey,
    restfulParams
  };
}

export const getIsInvalid = ({
  selectedList,
  openedAction
}) => {
  let isInvalid = false;

  return isInvalid;
}

export const getCleanSavingPayload = ({
  selectedList,
  openedAction
}) => {
  const savingPayloads = selectedList.map(client => {
    const {
      ...restClient
    } = client;

    return {
      ...restClient,
    }
  })

  return {
    data: savingPayloads
  }
}